/**
 * Most selected people one re-score run takes (2026-10-23). The confirm refuses a larger
 * selection up front and the routes refuse it at the schema, so a person is told to narrow the
 * selection instead of watching a count that never arrives. The other bulk actions on the People
 * table chunk at the same size.
 */
export const RESCORE_MAX = 500;
